var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnCommentOfComment = function SvgIcnCommentOfComment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00007 9.16375V10.2514V10.2515V10.2516L2 10.2515V10.2516V10.2517V11.3394V13.2991C2 13.8752 2.65693 14.2047 3.11861 13.8602L4.95534 12.4897H12.5C13.3284 12.4897 14 11.8181 14 10.9897V3.5C14 2.67157 13.3284 2 12.5 2H3.50007C2.67164 2 2.00007 2.67157 2.00007 3.5V9.16375ZM3 11.7675V12.701L4.35732 11.6882L4.62338 11.4897H4.95534H12.5C12.7761 11.4897 13 11.2659 13 10.9897V3.5C13 3.22386 12.7761 3 12.5 3H3.50007C3.22393 3 3.00007 3.22386 3.00007 3.5V10.2516V11.7676L3 11.7675ZM5.18115 8.49273C5.18115 8.2178 5.42972 7.99493 5.73635 7.99493H10.3323C10.6389 7.99493 10.8875 8.2178 10.8875 8.49273C10.8875 8.76765 10.6389 8.99052 10.3323 8.99052H5.73635C5.42972 8.99052 5.18115 8.76765 5.18115 8.49273ZM5.73635 5.50595C5.42972 5.50595 5.18115 5.72882 5.18115 6.00375C5.18115 6.27867 5.42972 6.50154 5.73635 6.50154H10.3323C10.6389 6.50154 10.8875 6.27867 10.8875 6.00375C10.8875 5.72882 10.6389 5.50595 10.3323 5.50595H5.73635Z",
    fill: "currentcolor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnCommentOfComment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_comment_of_comment.7afd595e.svg";
export { ForwardRef as ReactComponent };